import { useState, useEffect, useRef } from "react";
import {
    FaArrowLeft,
    FaCheck,
    FaCheckDouble,
    FaPaperPlane,
    FaUser,
    FaSearch,
    FaEllipsisV,
    FaTrash
} from "react-icons/fa";
import "./Conversations.css";
import { get, post, patchRequest, deleteRequest } from "../http/api";
import { useNavigate, useLocation } from "react-router-dom";
import { socket } from "../socket";
import SharedPost from "./SharedPost";
import SharedProfile from "./SharedProfile";
import PostModal from "./PostModal";
import { useTranslation } from "react-i18next";
import { API_URL, UPLOADS_URL } from "../config";
import { getMediaUrl } from "../http/media";
import { useConfirmModal } from "../components/reusable/ConfirmModalContext";




export default function Conversations({ onConversationOpen, selectedUserId, selectedUsername, selectedUserPhoto, onSelectedUserHandled }) {
    const [activeConv, setActiveConv] = useState(null);
    const [input, setInput] = useState("");
    const [conversations, setConversations] = useState([]);
    const [messages, setMessages] = useState([]);
    const [isTyping, setIsTyping] = useState(false);
    const [loadingConversations, setLoadingConversations] = useState(true);
    const [searchConv, setSearchConv] = useState("");
    const [openedMenu, setOpenedMenu] = useState(null);
    const [canMessage, setCanMessage] = useState(false);

    const { openConfirmModal, closeModal } = useConfirmModal();

    const [selectedMessage, setSelectedMessage] = useState(null);


    const [loadingMessages, setLoadingMessages] = useState(false);

    const [openedPostId, setOpenedPostId] = useState(null);
    const [openCommentsOnModal, setOpenCommentsOnModal] = useState(false);
    const [highlightedCommentId, setHighlightedCommentId] = useState(null);


    const navigate = useNavigate();
    const location = useLocation();

    const { t } = useTranslation();

    const fromProfile = location.state?.fromProfile;

    const currentUserId = sessionStorage.getItem("id_user");

    const messagesEndRef = useRef(null);
    const messagesContainerRef = useRef(null);

    useEffect(() => {
        if (onConversationOpen) {
            onConversationOpen(!!activeConv);
        }
    }, [activeConv]);

    useEffect(() => {
        if (currentUserId) {
            socket.emit(
                "join",
                currentUserId
            );
        }

    }, [currentUserId]);

    useEffect(() => {
        socket.on("new_message", (msg) => {
            if (
                activeConv &&
                msg.conversation_id === activeConv.id_conversation
            ) {
                setMessages((prev) => [...prev, msg]);
            }

            fetchConversations();
        });

        return () => socket.off("new_message");
    }, [activeConv]);

    useEffect(() => {
        socket.on("typing", () => setIsTyping(true));
        socket.on("stop_typing", () => setIsTyping(false));

        return () => {
            socket.off("typing");
            socket.off("stop_typing");
        };
    }, []);


    useEffect(() => {
        if (!messages.length || loadingMessages) return;

        const container = messagesContainerRef.current;

        if (!container) return;

        setTimeout(() => {
            container.scrollTop = container.scrollHeight;
        }, 50);

    }, [messages, loadingMessages, isTyping]);


    const handleBack = () => {
        if (fromProfile) {
            navigate(-1);
        } else {
            setActiveConv(null);
        }
    };



    // useEffect(() => {
    //     if (!selectedUserId) return;

    //     const existingConv = conversations.find(
    //         c => parseInt(c.other_user_id) === parseInt(selectedUserId)
    //     );

    //     if (existingConv) {
    //         setActiveConv(existingConv);
    //         fetchMessages(existingConv.id_conversation);
    //     } else if (conversations.length >= 0) {
    //         const tempConv = {
    //             id_conversation: null,
    //             other_user_id: selectedUserId,
    //             username: selectedUsername,
    //             user_photo: selectedUserPhoto
    //         };

    //         setActiveConv(tempConv);
    //     }

    // }, [selectedUserId, conversations]);

    useEffect(() => {
        if (!selectedUserId || loadingConversations) return;

        const existingConv = conversations.find(
            c =>
                Number(c.other_user_id) ===
                Number(selectedUserId)
        );

        if (!existingConv) {
            setActiveConv({
                id_conversation: null,
                other_user_id: selectedUserId,
                username: selectedUsername,
                user_photo: selectedUserPhoto
            });
            setMessages([]);
            onSelectedUserHandled?.();
            return;
        }

        if (
            activeConv?.id_conversation ===
            existingConv.id_conversation
        ) {
            return;
        }

        setActiveConv(existingConv);
        fetchMessages(existingConv.id_conversation);
        onSelectedUserHandled?.();

    }, [
        selectedUserId,
        selectedUsername,
        selectedUserPhoto,
        conversations,
        loadingConversations,
        onSelectedUserHandled
    ]);

    useEffect(() => {
        fetchConversations();
    }, []);

    useEffect(() => {
        let cancelled = false;
        async function checkAccess() {
            if (!activeConv?.other_user_id) {
                setCanMessage(false);
                return;
            }
            try {
                const response = activeConv.id_conversation
                    ? await get(`messages/access/${activeConv.id_conversation}`)
                    : await get(`matches/status/${activeConv.other_user_id}`);
                if (cancelled) return;
                setCanMessage(activeConv.id_conversation
                    ? response.data?.can_message === true
                    : response.data?.status === "matched" && response.data?.messaging_available !== false);
            } catch {
                if (!cancelled) setCanMessage(false);
            }
        }
        checkAccess();
        return () => { cancelled = true; };
    }, [activeConv?.id_conversation, activeConv?.other_user_id]);

    const fetchConversations = async () => {
        try {
            setLoadingConversations(true);

            const res = await get("messages/conversations");
            const data = res.data || [];

            setConversations(data);

        } catch (err) {
            console.error(err);
        } finally {
            setLoadingConversations(false);
        }
    };


    const handleDeleteConversation = async (
        conversationId
    ) => {

        try {

            await deleteRequest(
                `messages/conversation/${conversationId}`
            );

            setConversations(prev =>
                prev.filter(
                    c =>
                        c.id_conversation !==
                        conversationId
                )
            );

            if (
                activeConv?.id_conversation ===
                conversationId
            ) {
                setActiveConv(null);
                setMessages([]);
            }

        } catch (err) {
            console.error(err);
        }
    };

    const confirmDeleteConversation = (
        conversationId
    ) => {

        openConfirmModal({
            title: t(
                "sportProfile.followModal.deleteConversationTitle"
            ),

            message: t(
                "sportProfile.followModal.deleteConversationMessage"
            ),

            confirmText: t("post.delete"),
            cancelText: t("post.cancel"),

            variant: "danger",

            onConfirm: async () => {

                await handleDeleteConversation(
                    conversationId
                );

                closeModal();
            }
        });
    };


    const fetchMessages = async (conversationId) => {
        console.log(
            "fetchMessages",
            conversationId
        );
        try {
            setLoadingMessages(true);
            setMessages([]);

            const res = await get(
                `messages/${conversationId}`
            );

            setMessages(res.data || []);

            await patchRequest(
                `messages/read/${conversationId}`
            );

            setConversations(prev =>
                prev.map(conv =>
                    conv.id_conversation === conversationId
                        ? {
                            ...conv,
                            unread_count: 0
                        }
                        : conv
                )
            );

            await patchRequest(
                `notifications/conversation/${conversationId}`
            );

        } catch (err) {
            console.error(err);
        } finally {
            setLoadingMessages(false);
        }
    };



    const handleTyping = (e) => {
        setInput(
            e.target.value
        );
        if (
            !activeConv
        ) return;
        socket.emit(
            "typing",
            {
                sender_id:
                    currentUserId,

                receiver_id:
                    activeConv.other_user_id
            }
        );
        clearTimeout(
            window.typingTimeout
        );
        window.typingTimeout =
            setTimeout(() => {
                socket.emit(
                    "stop_typing",
                    {
                        sender_id:
                            currentUserId,
                        receiver_id:
                            activeConv.other_user_id
                    }
                );
            }, 1000);
    };



    const handleSendMessage = async () => {
        if (!input.trim() || !activeConv || !canMessage) return;

        const text = input;

        setInput("");

        const tempMessage = {
            id_message: Date.now(),
            sender_id: currentUserId,
            message: text,
            type: "text",
            is_read: 0,
            created_at: new Date().toISOString(),
            is_temp: true

        };

        setMessages(prev => [
            ...prev,
            tempMessage
        ]);

        try {

            const response = await post("messages", {
                receiver_id: activeConv.other_user_id,
                message: text
            });

            const conversationId = response?.data?.conversation_id;

            if (!activeConv.id_conversation && conversationId) {
                setActiveConv(prev => ({
                    ...prev,
                    id_conversation: conversationId
                }));
            }

            await fetchConversations();

            setConversations(prev =>
                prev.map(conv =>
                    conv.id_conversation === activeConv.id_conversation
                        ? {
                            ...conv,
                            last_message: text
                        }
                        : conv
                )
            );

        } catch (err) {
            console.error(err);
        }
    };

    const filteredConversations = conversations.filter((conv) =>
        conv.username
            .toLowerCase()
            .includes(searchConv.toLowerCase())
    );



    const confirmDeleteMessage = (
        messageId
    ) => {

        openConfirmModal({
            title: t(
                "conversations.deleteMessageTitle"
            ),

            message: t(
                "conversations.deleteMessageMessage"
            ),

            confirmText: t(
                "conversations.deleteMessageConfirm"
            ),

            variant: "danger",

            onConfirm: () => {

                deleteMessageForEveryone(messageId);
            }
        });

    };

    const deleteMessageForEveryone = async (
        messageId
    ) => {

        try {

            await patchRequest(
                `messages/delete/${messageId}`
            );

            setMessages(prev =>
                prev.map(msg =>
                    msg.id_message === messageId
                        ? {
                            ...msg,
                            is_deleted: 1
                        }
                        : msg
                )
            );


            const deletedMessage =
                messages.find(
                    m =>
                        m.id_message ===
                        messageId
                );

            if (
                deletedMessage &&
                activeConv
            ) {

                const lastMessage =
                    messages[
                    messages.length - 1
                    ];

                if (
                    lastMessage.id_message ===
                    messageId
                ) {

                    setConversations(prev =>
                        prev.map(conv =>
                            conv.id_conversation ===
                                activeConv.id_conversation
                                ? {
                                    ...conv,
                                    last_message:
                                        t(
                                            "conversations.messageDeleted"
                                        )
                                }
                                : conv
                        )
                    );

                }

            }

        } catch (err) {
            console.error(err);
        }

    };

    const openMessageActions = (msg) => {
        confirmDeleteMessage(msg.id_message);
    };

    useEffect(() => {

        if (!selectedMessage) return;

        console.log(
            "Message sélectionné :",
            selectedMessage
        );

    }, [selectedMessage]);





    const formatMessageDate = (date) => {

        const messageDate = new Date(date);

        const today = new Date();

        const yesterday = new Date();
        yesterday.setDate(
            yesterday.getDate() - 1
        );

        if (
            messageDate.toDateString() ===
            today.toDateString()
        ) {
            return t("conversations.today");
        }

        if (
            messageDate.toDateString() ===
            yesterday.toDateString()
        ) {
            return t("conversations.yesterday");
        }

        return messageDate.toLocaleDateString();
    };

    const formatMessageTime = (
        date
    ) => {

        return new Date(
            date
        ).toLocaleTimeString(
            [],
            {
                hour: "2-digit",
                minute: "2-digit"
            }
        );

    };


    useEffect(() => {

        socket.on(
            "message_deleted",
            ({
                message_id,
                conversation_id
            }) => {

                setMessages(prev =>
                    prev.map(msg =>
                        msg.id_message ===
                            message_id
                            ? {
                                ...msg,
                                is_deleted: 1
                            }
                            : msg
                    )
                );

                setConversations(prev =>
                    prev.map(conv =>
                        conv.id_conversation ===
                            conversation_id
                            ? {
                                ...conv,
                                last_message: t(
                                    "conversations.messageDeleted"
                                )
                            }
                            : conv
                    )
                );

            }
        );

        return () => {
            socket.off(
                "message_deleted"
            );
        };

    }, [t]);



    return (
        <div
            className={`ig-chat-layout ${activeConv ? "chat-open" : ""
                }`}
        >
            <aside className="ig-sidebar">
                <div className="ig-sidebar-header">
                    <h2>{t("conversations.title")}</h2>

                    <div className="ig-search">
                        <FaSearch />

                        <input
                            type="text"
                            placeholder={t("conversations.search")}
                            value={searchConv}
                            onChange={(e) =>
                                setSearchConv(e.target.value)
                            }
                        />
                    </div>
                </div>

                <div className="ig-conversations">
                    {loadingConversations ? (
                        Array.from({ length: 6 }).map((_, i) => (
                            <div
                                key={i}
                                className="conv-item skeleton-conv"
                            >
                                <div className="avatar skeleton"></div>

                                <div className="conv-info">
                                    <div className="skeleton name"></div>
                                    <div className="skeleton message"></div>
                                </div>
                            </div>
                        ))
                    ) : filteredConversations.length === 0 ? (
                        <div className="empty-conversations">
                            <div className="empty-icon">💬</div>
                            <h3>
                                {t("conversations.emptyConversationsTitle")}
                            </h3>
                            <p>
                                {t("conversations.emptyConversationsText")}
                            </p>
                        </div>
                    ) : (
                        filteredConversations.map((conv) => (
                            <div
                                key={conv.id_conversation}
                                className={`conv-item ${activeConv?.id_conversation ===
                                    conv.id_conversation
                                    ? "active"
                                    : ""
                                    }`}
                                onClick={() => {
                                    setActiveConv(conv);
                                    fetchMessages(conv.id_conversation);
                                }}
                            >
                                <div className="avatar">
                                    {conv.user_photo ? (
                                        <img
                                            src={getMediaUrl(conv.user_photo)}
                                            // src={`${API_URL}${conv.user_photo}`}
                                            alt=""
                                        />
                                    ) : (
                                        <FaUser />
                                    )}
                                </div>


                                <div className="conv-info">
                                    <strong>{conv.username}</strong>

                                    <span className="last-message">
                                        {conv.last_message_type === "profile" || /profil|profile/i.test(conv.last_message || "")
                                            ? t("conversations.sharedProfile")
                                            : conv.last_message}
                                    </span>
                                </div>

                                {conv.unread_count > 0 && (
                                    <div className="unread-badge">
                                        {conv.unread_count}
                                    </div>
                                )}

                                <div
                                    className="conversation-actions"
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    <FaEllipsisV
                                        className="conversation-menu-btn"
                                        onClick={() =>
                                            setOpenedMenu(
                                                openedMenu === conv.id_conversation
                                                    ? null
                                                    : conv.id_conversation
                                            )
                                        }
                                    />

                                    {openedMenu === conv.id_conversation && (
                                        <div className="conversation-menu">
                                            <button
                                                onClick={() =>
                                                    confirmDeleteConversation(
                                                        conv.id_conversation
                                                    )
                                                }
                                            >
                                                <FaTrash />
                                                {t("post.delete")}
                                            </button>
                                        </div>
                                    )}
                                </div>

                            </div>
                        ))
                    )}
                </div>
            </aside>

            <section className="ig-chat-panel">
                {!activeConv ? (
                    <div className="empty-chat-panel">
                        <div className="empty-icon">✉️</div>
                        <h2>{t("conversations.emptyChatTitle")}</h2>
                        <p>
                            {t("conversations.emptyChatText")}
                        </p>
                    </div>
                ) : (
                    <>
                        <div className="chat-header">
                            <FaArrowLeft
                                className="mobile-back"
                                onClick={handleBack}
                            />

                            <div className="avatar small">
                                {activeConv.user_photo ? (
                                    <img
                                        src={getMediaUrl(activeConv.user_photo)}
                                        // src={`${API_URL}/${activeConv.user_photo}`}
                                        alt=""
                                    />
                                ) : (
                                    <FaUser />
                                )}
                            </div>



                            <h3>{activeConv.username}</h3>
                        </div>

                        <div className="messages" ref={messagesContainerRef}>
                            {loadingMessages ? (
                                Array.from({ length: 6 }).map((_, i) => (
                                    <div
                                        key={i}
                                        className={`message-skeleton ${i % 2 ? "me" : "them"
                                            }`}
                                    />
                                ))
                            ) : (
                                messages.map((msg, index) => {

                                    const previousMessage =
                                        messages[index - 1];

                                    const showDateSeparator =
                                        !previousMessage ||
                                        new Date(
                                            previousMessage.created_at
                                        ).toDateString() !==
                                        new Date(
                                            msg.created_at
                                        ).toDateString();

                                    return (
                                        <>
                                            {showDateSeparator && (
                                                <div
                                                    className="date-separator"
                                                >
                                                    {formatMessageDate(
                                                        msg.created_at
                                                    )}
                                                </div>
                                            )}

                                            <div
                                                key={msg.id_message}
                                                className={`message ${parseInt(msg.sender_id) ===
                                                    parseInt(currentUserId)
                                                    ? "me"
                                                    : "them"
                                                    }`}
                                                onDoubleClick={() => {

                                                    if (
                                                        msg.is_temp
                                                    ) {
                                                        return;
                                                    }

                                                    if (
                                                        parseInt(msg.sender_id) ===
                                                        parseInt(currentUserId)
                                                    ) {
                                                        openMessageActions(msg);
                                                    }

                                                }}
                                            >
                                                {/* {msg.type === "text" &&
                                            msg.message} */}
                                                {msg.type === "text" && (

                                                    msg.is_deleted === 1 ? (

                                                        <div className="deleted-message">
                                                            {t(
                                                                "conversations.messageDeleted"
                                                            )}
                                                        </div>

                                                    ) : (

                                                        <>
                                                            {msg.message}

                                                            {msg.is_edited === 1 && (
                                                                <div
                                                                    className="edited-label"
                                                                >
                                                                    {t(
                                                                        "conversations.edited"
                                                                    )}
                                                                </div>
                                                            )}
                                                        </>

                                                    )

                                                )}

                                                {msg.type === "post" && (
                                                    <SharedPost
                                                        postId={msg.post_id}
                                                        onOpenPost={(postId) => {
                                                            setOpenedPostId(postId);
                                                        }}
                                                    />
                                                )}

                                                {msg.type === "profile" && msg.is_deleted !== 1 && (
                                                    <SharedProfile url={msg.message} />
                                                )}

                                                <div className="message-footer">

                                                    <span className="message-time">
                                                        {formatMessageTime(
                                                            msg.created_at
                                                        )}
                                                    </span>

                                                    {parseInt(msg.sender_id) ===
                                                        parseInt(currentUserId) && (
                                                            <span className="message-status">
                                                                {parseInt(msg.is_read) === 1
                                                                    ? <FaCheckDouble />
                                                                    : <FaCheck />}
                                                            </span>
                                                        )}

                                                </div>

                                                {/* {parseInt(msg.sender_id) === parseInt(currentUserId) && (
                                                    <span className="message-status">
                                                        {parseInt(msg.is_read) === 1 ? (
                                                            <FaCheckDouble />
                                                        ) : (
                                                            <FaCheck />
                                                        )}
                                                    </span>
                                                )} */}
                                            </div>
                                        </>
                                    );
                                })
                            )



                                // old func
                                //     messages.map((msg) => (
                                // <div
                                //     key={msg.id_message}
                                //     className={`message ${parseInt(msg.sender_id) ===
                                //         parseInt(currentUserId)
                                //         ? "me"
                                //         : "them"
                                //         }`}
                                //     onDoubleClick={() => {

                                //         if (
                                //             parseInt(msg.sender_id) ===
                                //             parseInt(currentUserId)
                                //         ) {
                                //             openMessageActions(msg);
                                //         }

                                //     }}
                                // >
                                //     {/* {msg.type === "text" &&
                                //                 msg.message} */}
                                //     {msg.type === "text" && (

                                //         msg.is_deleted === 1 ? (

                                //             <div className="deleted-message">
                                //                 {t(
                                //                     "conversations.messageDeleted"
                                //                 )}
                                //             </div>

                                //         ) : (

                                //             <>
                                //                 {msg.message}

                                //                 {msg.is_edited === 1 && (
                                //                     <div
                                //                         className="edited-label"
                                //                     >
                                //                         {t(
                                //                             "conversations.edited"
                                //                         )}
                                //                     </div>
                                //                 )}
                                //             </>

                                //         )

                                //     )}

                                //     {msg.type === "post" && (
                                //         <SharedPost
                                //             postId={msg.post_id}
                                //             onOpenPost={(postId) => {
                                //                 setOpenedPostId(postId);
                                //             }}
                                //         />
                                //     )}

                                //     {parseInt(msg.sender_id) === parseInt(currentUserId) && (
                                //         <span className="message-status">
                                //             {parseInt(msg.is_read) === 1 ? (
                                //                 <FaCheckDouble />
                                //             ) : (
                                //                 <FaCheck />
                                //             )}
                                //         </span>
                                //     )}
                                // </div>
                                // )
                            }



                            {isTyping && (
                                <div className="typing-indicator">
                                    {t("conversations.typing")}
                                </div>
                            )}

                            <div ref={messagesEndRef} />
                        </div>

                        {canMessage ? <div className="chat-input">
                            <textarea
                                placeholder={t("conversations.writeMessage")}
                                value={input}
                                onChange={handleTyping}
                                rows={1}
                                className="chat-textarea"
                            />

                            <button onClick={handleSendMessage}>
                                <FaPaperPlane />
                            </button>
                        </div> : <div className="chat-input" role="status">
                            <span>{t("conversations.premiumLocked")}</span>
                        </div>}
                    </>
                )}
            </section>

            {openedPostId && (
                <PostModal
                    postId={openedPostId}

                    openComments={openCommentsOnModal}

                    highlightedCommentId={highlightedCommentId}

                    onClose={() => {
                        setOpenedPostId(null);
                        setOpenCommentsOnModal(false);
                        setHighlightedCommentId(null);
                    }}
                />
            )}

        </div>
    );
}
